import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';

function LogoIcon() {
  return (
    <svg viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: 38, height: 38 }}>
      {/* Ring luar berputar */}
      <circle cx="22" cy="22" r="20" stroke="url(#ring)" strokeWidth="1.5" strokeDasharray="8 4" fill="none" style={{ transformOrigin: '22px 22px', animation: 'spinRing 6s linear infinite' }} />
      {/* Lingkaran dalam */}
      <circle cx="22" cy="22" r="17" stroke="url(#g1)" strokeWidth="1" fill="rgba(0,220,180,0.07)" />
      {/* Chart line */}
      <path d="M12 22 L16 17 L20 21 L24 14 L32 22" stroke="url(#g2)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      {/* Dot bawah */}
      <circle cx="22" cy="27" r="3" fill="url(#g2)" opacity="0.9" />
      <defs>
        <linearGradient id="ring" x1="0" y1="0" x2="44" y2="44" gradientUnits="userSpaceOnUse">
          <stop stopColor="#00dcb4"/>
          <stop offset="0.5" stopColor="#3b82f6"/>
          <stop offset="1" stopColor="#00dcb4"/>
        </linearGradient>
        <linearGradient id="g1" x1="0" y1="0" x2="44" y2="44" gradientUnits="userSpaceOnUse">
          <stop stopColor="#00dcb4"/>
          <stop offset="1" stopColor="#3b82f6"/>
        </linearGradient>
        <linearGradient id="g2" x1="12" y1="14" x2="32" y2="28" gradientUnits="userSpaceOnUse">
          <stop stopColor="#00dcb4"/>
          <stop offset="1" stopColor="#00f5c8"/>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default function Navbar() {
  const { totalItems } = useCart();
  const navigate = useNavigate();

  return (
    <nav className="navbar">
      <div
        className="navbar-brand"
        onClick={() => navigate('/')}
        role="button"
        tabIndex={0}
        onKeyDown={e => e.key === 'Enter' && navigate('/')}
      >
        <div className="logo-mark">
          <LogoIcon />
        </div>
        <div className="logo-text">
          <span className="t1">Digital</span>
          <span className="t2">// store</span>
        </div>
      </div>

      <div className="navbar-links">
        <Link to="/" className="nav-link">Produk</Link>
        <Link to="/riwayat" className="nav-link">Riwayat</Link>
        <Link to="/cart" className="cart-pill">
          🛒 Keranjang
          {totalItems > 0 && <span className="cart-count">{totalItems}</span>}
        </Link>
      </div>
    </nav>
  );
}
